import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0ZM7.5 11.25C6.9375 11.25 6.5625 10.875 6.5625 10.3125C6.5625 9.75 6.9375 9.375 7.5 9.375C8.0625 9.375 8.4375 9.75 8.4375 10.3125C8.4375 10.875 8.0625 11.25 7.5 11.25ZM8.4375 8.4375H6.5625V3.75H8.4375V8.4375Z",
		fill: "currentColor"
	})
});
export default SvgIconAlert;
